export default __webpack_public_path__ + "static/media/shieldsweep2.65ebeb96.png";